import { createContext, useContext } from "react";

const PitchContext = createContext(null);

export const PitchProvider = ({ value, children }) => (
  <PitchContext.Provider value={value}>{children}</PitchContext.Provider>
);

export const usePitch = () => useContext(PitchContext);
